/* eslint-disable canonical/filename-match-regex */
import { defineMessages } from 'react-intl';

export const a11yCommonMessages = defineMessages({
    a11yCloseText: {
        defaultMessage: 'Schließen',
    },
});
